import React, {useEffect} from 'react'
import {Grid, Alert, CircularProgress} from '@mui/material'
import CheckInQuestion from './CheckInQuestion'
import SurveyBlock from './SurveyBlock'
import checkinApi from '../../../services/api/checkin/checkinApi'

export default function SelectSurvey({
  surveyIds,
  setSurveyIds,
  checkInQuestion,
  setCheckInQuestion,
}) {
  const [surveys, setSurveys] = React.useState([])
  const [loading, setLoading] = React.useState(false)

  useEffect(() => {
    setLoading(true)
    checkinApi

      .getAll()
      .then(res => {
        if (res) {
          setSurveys(res)
          if (surveyIds.length > 0) {
            let s = res.filter(x => surveyIds.indexOf(x.id) > -1)
            setSurveyIds(s)
          }
        } else {
          setSurveys([])
        }
      })
      .catch(err => console.error('Error fetching check-in surveys:', err))
      .finally(() => setLoading(false))
  }, [])

  const getCheckInSurveyCount = () => {
    let count = 0
    if (surveyIds.length > 0) {
      surveyIds.forEach(survey => {
        count += survey?.surveyQuestions?.length
      })
    }
    return count % 5 === 0 ? count / 5 : Math.floor(count / 5) + 1
  }

  return (
    <>
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={4}>
          <div className="info-panel">
            You can select up to three evidenced backed mental health and
            wellbeing surveys to be included in your check-ins. The surveys will
            be split so that each survey has no more than 6 questions, including
            your check-in question.
          </div>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={4}>
          <h3>
            <strong>Select Survey</strong>
          </h3>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
          <Grid container>
            {loading && <CircularProgress />}
            {!loading && surveys?.length === 0 && (
              <Alert severity="info">
                No check-in survey templates are available yet.
              </Alert>
            )}
            {surveys?.length > 0 &&
              surveys?.map((survey, index) => (
                <SurveyBlock
                  survey={survey}
                  setSurveyIds={setSurveyIds}
                  surveyIds={surveyIds}
                />
              ))}
          </Grid>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
          {getCheckInSurveyCount() > 0 && (
            <Alert severity="success">
              The full suite of surveys will be completed in{' '}
              {getCheckInSurveyCount()} check-in surveys
            </Alert>
          )}
        </Grid>
      </Grid>
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={4}>
          <h3>
            <strong>Check-in Question</strong>
          </h3>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
          <CheckInQuestion
            canChange={true}
            checkInQuestion={checkInQuestion}
            setCheckInQuestion={setCheckInQuestion}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
          <Alert severity="info">
            Students will be offered the opportunity to start a safe space
            conversation if they select the lowest two answer options.
          </Alert>
        </Grid>
      </Grid>
    </>
  )
}
